import { BasketAccount } from '@epicuro-next/data/baskets-dto';

// some way basket items has no delivery
// this stub account is used to prevent failing load basket and have possibility for proper Address and Delivery grouping
// address have no realAddressId so, UI handle this basket as basket with deleted address and make it not editable
// this stub has minimum fields to keep basket schema without changing. As making fields nullable leads to huge changes
export const DELIVERY_STUB_ID = 'DELIVERY_STUB_ID';
export const BASKET_ACCOUNT_STUB_ID = 'BASKET_ACCOUNT_STUB_ID';
export const ACCOUNT_STUB_ID = 'ACCOUNT_STUB_ID';
export const ADDRESS_STUB_ID = 'ADDRESS_STUB_ID';
export const ADDRESS_STUB_NAME = 'ADDRESS_STUB_NAME';

export const DELIVERY_STUB = {
  deliveryId: DELIVERY_STUB_ID,
};

export const ADDRESS_STUB = {
  addressId: ADDRESS_STUB_ID,
  name: ADDRESS_STUB_NAME,
};

export const BASKET_ACCOUNT_STUB = {
  basketAccountId: BASKET_ACCOUNT_STUB_ID,
  account: {
    accountId: ACCOUNT_STUB_ID,
  },
  addressId: ADDRESS_STUB_ID,
  address: ADDRESS_STUB,
  deliveries: [DELIVERY_STUB],
} as BasketAccount;
